var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"breadcrumb"},[_vm._t("header",function(){return [_c('h1',[_vm._v(_vm._s(_vm.page))]),_c('ul',[_c('li',[_c('a',{attrs:{"href":""}},[_vm._v(" "+_vm._s(_vm.folder)+" ")])]),_c('li',[_vm._v(" "+_vm._s(_vm.page)+" ")])])]})],2),_c('div',{staticClass:"separator-breadcrumb border-top"})])
}
var staticRenderFns = []

export { render, staticRenderFns }